<template>
  <div class="devOpsTopAnalysis">
    <div class="row selectBox">
      <ul>
        <li
          v-for="(v, i) in selectList"
          :key="v.key"
          :class="{ activeLi: v.key == selectList[ecActive].key }"
          @click="changeCard(i)"
        >
          <h5>{{ v.value }}</h5>
          <p>{{ v.name }}</p>
        </li>
      </ul>
    </div>
    <div class="row">
      <PublicEcharts :id="'pie'" :chartsData="pieCharts" :type="'pieChart'" />
    </div>
    <div class="row">
      <PublicEcharts
        :id="'ring1'"
        :chartsData="ringCharts1"
        :type="'ringChart'"
      />
    </div>
    <div class="row" v-if="activeName == '告警记录'">
      <PublicEcharts
        :id="'ring2'"
        :chartsData="ringCharts2"
        :type="'ringChart'"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
import PublicEcharts from "@/components/PublicEcharts";
export default {
  props: {
    activeName: {
      type: String,
      default: "",
    },
    system: {
      type: String,
      default: "",
    },
  },
  components: {
    PublicEcharts,
  },
  watch: {
    activeName: {
      handler(newvalue, oldvalue) {
        this.handlerChange();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      selectList: [],
      ecActive: 0,
      pieCharts: { unit: "条", dataArr: [] },
      ringCharts1: {
        unit: "",
        dataArr: [],
      },
      ringCharts2: {
        unit: "",
        dataArr: [],
      },
    };
  },
  methods: {
    handlerChange() {
      this.ecActive = 0;
      this.selectList = [
        {
          name: `今日${this.activeName == "工单" ? "工单" : "报警"}`,
          value: null,
          key: "today",
          startTime: new Date(
            dateFtt("yyyy-MM-dd 00:00:00", new Date())
          ).getTime(),
        },
        {
          name: `本月${this.activeName == "工单" ? "工单" : "报警"}`,
          value: null,
          key: "month",
          startTime: new Date(
            dateFtt("yyyy-MM-01 00:00:00", new Date())
          ).getTime(),
        },
        {
          name: `今年${this.activeName == "工单" ? "工单" : "报警"}`,
          value: null,
          key: "year",
          startTime: new Date(
            dateFtt("yyyy-01-01 00:00:00", new Date())
          ).getTime(),
        },
        {
          name: `累积${this.activeName == "工单" ? "工单" : "报警"}`,
          value: null,
          key: "total",
          startTime: new Date("2021-01-01 00:00:00").getTime(),
        },
      ];
      if (this.activeName == "工单") {
        this.getWorksheetsTol();
        this.getWorksheetsCharts();
      } else if (this.activeName == "告警") {
        this.getAlarmTol();
        this.getAlarmCharts();
      }
    },
    changeCard(i) {
      this.ecActive = i;
      if (this.activeName == "工单") {
        this.getWorksheetsCharts();
      } else {
        this.getAlarmCharts();
      }
    },
    /************ 工单记录 ***********/
    async getWorksheetsTol() {
      let res = await api.devOpsWorksheetsTol({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.system,
      });
      if (res && res.data.code == 200) {
        this.selectList.map((v) => {
          v.value = res.data.data[v.key];
        });
      }
    },
    async getWorksheetsCharts() {
      this.pieCharts.dataArr = [
        { value: null, name: "紧急", key: "HIGH" },
        { value: null, name: "重要", key: "MEDIUM" },
        { value: null, name: "一般", key: "LOW" },
        { value: null, name: "安全隐患", key: "SAFETY_HAZARD" },
      ];
      this.ringCharts1 = {
        unit: "",
        dataArr: [
          { value: null, name: "待派单", key: "TOBE_ASSIGNED" },
          { value: null, name: "待重新派单", key: "TOBE_RE_ASSIGNED" },
          { value: null, name: "待处理", key: "TOBE_REPAIR" },
          { value: null, name: "待确认", key: "TOBE_CONFIRMED" },
          { value: null, name: "已完成", key: "COMPLETED" },
          { value: null, name: "已关闭", key: "INVALID" },
        ],
      };

      let res = await api.devOpsWorksheetsCharts({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.system,
        startTime: this.selectList[this.ecActive].startTime,
        endTime: new Date().getTime(),
      });
      if (res && res.data.code == 200) {
        res.data.data.priority;
        this.pieCharts.dataArr.map((v) => {
          v.value = res.data.data.priority[v.key]
            ? res.data.data.priority[v.key]
            : 0;
        });
        this.ringCharts1.dataArr.map((v) => {
          v.value = res.data.data.status[v.key]
            ? res.data.data.status[v.key]
            : 0;
        });
        this.ringCharts1.unit = this.ringCharts1.dataArr[0].unit ?? "";
      }
    },

    /************ 告警记录 ***********/
    async getAlarmTol() {
      let res = await api.devOpsAlarmTol({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.system,
      });
      if (res && res.data.code == 200) {
        this.selectList.map((v) => {
          v.value = res.data.data[v.key];
        });
      }
    },
    async getAlarmCharts() {
      this.pieCharts.dataArr = [
        { value: null, name: "高危", key: "CRITICAL" },
        { value: null, name: "危险", key: "MAJOR" },
        { value: null, name: "警告", key: "MINOR" },
      ];
      this.ringCharts1 = {
        unit: "",
        dataArr: [
          { value: null, name: "已确认", key: "ackeded" },
          { value: null, name: "未确认", key: "unackeded" },
        ],
      };
      this.ringCharts2 = {
        unit: "",
        dataArr: [
          { value: null, name: "已转工单", key: "transferreded" },
          { value: null, name: "未转工单", key: "untransferreded" },
        ],
      };
      let res = await api.devOpsAlarmCharts({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceType: this.system,
        startTime: this.selectList[this.ecActive].startTime,
        endTime: new Date().getTime(),
      });
      if (res && res.data.code == 200) {
        this.pieCharts.dataArr.map((v) => {
          v.value = res.data.data.severity[v.key]
            ? res.data.data.severity[v.key]
            : 0;
        });
        this.ringCharts1.dataArr.map((v) => {
          v.value = res.data.data.acked[v.key] ? res.data.data.acked[v.key] : 0;
        });
        this.ringCharts1.unit = this.ringCharts1.dataArr[0].unit ?? "条";
        this.ringCharts2.dataArr.map((v) => {
          v.value = res.data.data.transferred[v.key]
            ? res.data.data.transferred[v.key]
            : 0;
        });
        this.ringCharts2.unit = this.ringCharts2.dataArr[0].unit ?? "条";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.devOpsTopAnalysis {
  width: 100%;
  height: 100%;
  @include setFlexAround;
  .row {
    width: 22%;
    height: 100%;
  }
  .selectBox {
    ul {
      width: 100%;
      height: 100%;
      @include setFlexBetween;
      flex-wrap: wrap;
      li {
        width: 49%;
        height: 49%;
        border-radius: 8px;
        @include setFlexColumn;
        justify-content: center;
        align-items: center;
        border: 1px solid transparent;
        h5 {
          font-size: 20px;
          margin: 5px 0;
        }
      }
      li:hover {
        background: #f8fafb;
      }
      .activeLi {
        background: #f8fafb;
        border: 1px solid #28cccb;
        h5 {
          color: #28cccb;
        }
      }
    }
  }
}
</style>
